const generateMarks = (marks: number[], color?: string) =>
    marks.reduce(
        (acc, mark) => ({
            ...acc,
            [mark]: {
                style: { color: color || 'white' },
                label: mark,
            },
        }),
        {}
    );

export { generateMarks };
